<ng-container>
	<mat-list dense class="password-container">
		<h1
			matSubheader
			class="password-requirement-header"
			style="color: #459cba; font-weight: bold"
			i18n="@@passwordValidation-passwordRequirements"
		>
			Password Requirements:
		</h1>
		<ul>
			@for (requirement of requirements; track requirement) {
				<mat-list-item class="list-item-password">
					<li class="password-validation-point">
						&bullet;&NonBreakingSpace;{{ requirement.label
						}}<mat-icon>{{ validatePassword(requirement.validator) }}</mat-icon>
					</li>
				</mat-list-item>
			}
		</ul>
	</mat-list>
</ng-container>
